import { createFileRoute } from '@tanstack/react-router';

import { WorkspaceExerciseFormScreen } from '@/features/exercises/components/WorkspaceExerciseFormScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/exercises/new')({
  beforeLoad: () => {
    requirePermission('engagement:create');
  },
  component: WorkspaceExerciseCreateRoute,
  staticData: { crumb: 'New' },
});

function WorkspaceExerciseCreateRoute() {
  return <WorkspaceExerciseFormScreen mode="create" surface="workspace" />;
}
